<script>
    import { link } from "svelte-routing";
    import { user } from "../../firebase/auth";
    import clickOutside from "../../utils/clickOutside";
    import LogoutButton from "../auth/LogoutButton.svelte";
    import MenuList from "../widgets/MenuList.svelte";
    import MenuListItem from "../widgets/MenuListItem.svelte";
    let expanded = false;
</script>

<div class="container" use:clickOutside={() => {expanded = false}}>
    <button aria-expanded={expanded} on:click={() => {expanded = !expanded}} aria-controls="account-settings-widget" aria-label={expanded?"Accountoptionen ausblenden":"Accountoptionen anzeigen"}>
        {$user.displayName.slice(0,1)}
        <!-- <img src="https://www.business2community.com/wp-content/uploads/2017/08/blank-profile-picture-973460_640.png" alt="" aria-hidden="true"> -->
    </button>

    {#if expanded}
        <div id="account-settings-widget">
            <div class="menu-list">
                <MenuList>
                    <MenuListItem icon="⚙️" text="Account" href="/account"/>
                    <MenuListItem icon="🙈" text="Datenschutz" href="/datenschutz"/>
                    <MenuListItem icon="🔥" text="Impressum" href="/impressum"/>
                </MenuList>
            </div>
            <LogoutButton />
            {$user?.uid}
        </div>
    {/if}
</div>


<style>
    .container {
        position: relative;
        width: 2rem;
        height: 2rem;
    }

    button {
        width: 100%;
        height: 100%;
        border-radius: 100%;
        display: block;
        overflow: hidden;
        margin: 0;
        padding: 0;
        background-color: #0047FF;
        color: white;
        font-weight: bold;
        font-size: 0.8rem;
        border: 0;
        text-transform: capitalize;
    }
    
    button:active {
        background-color: #0047FF;
    }

    #account-settings-widget {
        position: absolute;
        background-color: white;
        border: 1px solid #eee;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
        top: 2.5rem;
        right: 0;
        border-radius: 0.5rem;
        padding: 0.5rem;
        display: flex;
        flex-direction: column;
    }

    .menu-list {
        margin: -0.5rem -0.5rem 0;
    }
</style>